import React, { Component } from 'react';
import cn from 'classnames';
import { mergeClassNames } from '../../utils/utilsGlobal';
import originalStyles from './Modal.scss';


export class Modal extends Component {

  componentDidMount(){
    document.body.addEventListener('keyup', this.onBodyKeyup);
  }

  componentWillUnmount(){
    document.body.removeEventListener('keyup', this.onBodyKeyup);
  }

  onBodyKeyup = (e) => {
    if (e.which === 27 /* Esc */) {
      this.props.onClose();
    }
  };

  render(){
    const {
      className,
      children,
      title,
      onClose,
      onClick,
      overrideClassNames,
      verticallyCentered,
    } = this.props;

    const styles = mergeClassNames(originalStyles, overrideClassNames);

    return (
      <div className={cn({
        [className]: true,
        [styles.container]: true,
        [styles.containerVerticallyCentered]: verticallyCentered,
      })} onClick={onClick}>
        <div className={styles.backdrop} onClick={onClose}/>
        <div className={styles.modal}>
          {Boolean(title) && (
            <h3 className={styles.title}>{title}</h3>
          )}
          <i className={cn(styles.close, 'icon-close-thin')} onClick={onClose}/>
          {children}
        </div>
      </div>
    );
  }
}
